import * as React from 'react';

import Slider from './Slider';
import ItemInfo from './ItemInfo';
import { DriveItemInfo } from '../../containers/DriveItemList/reducer';
import usePreviousValue from '../../utils/customHooks/usePreviousValue';

interface CoverFlowProps {
	idsToDisplay: number[];
	folderId?: number;
	driveItems: { [k: number]: DriveItemInfo };
	children: React.ReactNode;
	navigationItemsLength?: number;
	onFolderChange: () => void;
	onSlideChange: (newIndex: number) => void;
}

const INITIAL_SLIDE_INDEX = 0;

const CoverFlow = ({
	folderId,
	children,
	idsToDisplay,
	driveItems,
	onFolderChange,
	onSlideChange,
	navigationItemsLength = 0,
}: CoverFlowProps) => {
	const [currentSlideIndex, setCurrentSlideIndex] = React.useState(INITIAL_SLIDE_INDEX);
	const slidesLength = idsToDisplay.length + navigationItemsLength;
	const prevSlidesLength = usePreviousValue(slidesLength);

	const handleSlideChange = (index: number) => {
		onSlideChange(index);
		setCurrentSlideIndex(index);
	};

	React.useEffect(() => {
		onFolderChange();
		setCurrentSlideIndex(INITIAL_SLIDE_INDEX);
	}, [folderId]);

	React.useEffect(() => {
		if (!prevSlidesLength) {
			return;
		}

		const isSlideAdded = slidesLength > prevSlidesLength;
		const isSlideRemoved = slidesLength < prevSlidesLength;

		if (isSlideAdded) {
			setCurrentSlideIndex(INITIAL_SLIDE_INDEX);
		}

		if (isSlideRemoved && currentSlideIndex === prevSlidesLength - 1) {
			setCurrentSlideIndex(currentSlideIndex - 1);
		}
	}, [slidesLength]);

	const navigationItemsIndexes = Array.from({ length: navigationItemsLength }, (v, i) => i);
	const isNavigationItem = navigationItemsIndexes.includes(currentSlideIndex);
	let currentDriveItem = driveItems[idsToDisplay[currentSlideIndex - navigationItemsLength]];
	let label = '';

	if (isNavigationItem && children) {
		currentDriveItem = children[currentSlideIndex].props;
		label = children[currentSlideIndex].props.itemLabel;
	}

	if (!currentDriveItem) {
		return null;
	}

	return (
		<>
			<Slider
				slidesLength={slidesLength}
				currentSlideIndex={currentSlideIndex}
				onSlideChange={handleSlideChange}
			>
				{children}
			</Slider>
			<ItemInfo
				currentDriveItem={currentDriveItem}
				isNavigationItem={isNavigationItem}
				label={label}
			/>
		</>
	);
};

export default CoverFlow;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CoverFlow/index.tsx